import { ETRIS01_DetailedAging } from "./ETRIS01_DetailedAging";

export const DetailedAgingReport = {
  "sections": [
    ETRIS01_DetailedAging
  ]
}